export default "__VITE_ASSET__DGsWM5Pd__"